import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { User } from '../../shared/models/user';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { SessionService } from '../../shared/services/session.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '../../shared/services/user.service';
import { NotificationService } from '../../shared/services/notification.service';
import { UserDialogComponent } from '../../user-dialog/user-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {YesNoDialogComponent} from "../../yesno-dialog/yesno-dialog.component";

@Component({
  selector: 'mbnm-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.scss']
})
export class PersonalInfoComponent implements OnInit, OnDestroy {

  constructor(private sessionService: SessionService,
    private userService: UserService,
    private router: Router,
    private notificationService: NotificationService,
    public dialog: MatDialog) { }


  editUser: any;
  user: User;
  editableInfo = false;
  passwordFormGroup: UntypedFormGroup = new UntypedFormGroup({
    old: new UntypedFormControl('', [<any>Validators.required, <any>Validators.minLength(6)]),
    new: new UntypedFormControl('', [<any>Validators.required, <any>Validators.minLength(6)]),
    confirm: new UntypedFormControl('', [<any>Validators.required, <any>Validators.minLength(6)])
  });

  @ViewChild('passform') passwordForm;

  currentUser: User;

  dialogRef: MatDialogRef<UserDialogComponent>;

  ngOnInit() {

    let guestLogin = false;

    this.userChangedSubscription = SessionService.currentUserChanged.subscribe((currentUser: User) => {
      if (guestLogin && (!this.currentUser || this.currentUser.isAnonymous)) {
        return;
      }

      this.currentUser = currentUser;
      if (!this.currentUser || this.currentUser.isAnonymous && !this.dialogRef) {
        this.dialogRef = this.dialog.open(UserDialogComponent, { disableClose: true });
        this.dialogRef.componentInstance.configs = {
          closeMethod : 'x'
        };
      } else {
        this.setUser();
      }
    });
  }

  ngOnDestroy() {
    if (this.userChangedSubscription && !this.userChangedSubscription.closed) {
      this.userChangedSubscription.unsubscribe();
    }
  }

  private userChangedSubscription;


  public signOut(): void {
    if (this.userChangedSubscription && !this.userChangedSubscription.closed) {
      this.userChangedSubscription.unsubscribe();
    }
    this.sessionService.signOutAndGetAnonymousUser();
    this.router.navigateByUrl('');

  }

  private setUser(user = null): void {
    this.user = user ? user : this.currentUser;

    if (this.user && !this.user.isAnonymous) {
      this.editUser = {
        fullname: this.user.fullname,
        phonenumber: this.user.phonenumber,
        email: this.user.email,
        email2: '',
        newsletterEmailState: this.user.subscriptions.newsletterEmailStatus === 'SUBSCRIBED',
        smsMarketingState: this.user.subscriptions.smsMarketingStatus === 'SUBSCRIBED',
        subscriptions: Object.assign({}, this.user.subscriptions)
      };
    }
  }

  public async saveUserInfo(eve: Event) {
    eve.preventDefault();
    if (this.editUser.email === this.user.email || this.editUser.email === this.editUser.email2) {
      if (this.editUser.smsMarketingState && this.editUser.subscriptions.smsMarketingStatus === 'NOT_SUBSCRIBED') {
        this.editUser.subscriptions.smsMarketingStatus = 'SUBSCRIBE_REQUESTED';
      } else if (!this.editUser.smsMarketingState && this.editUser.subscriptions.smsMarketingStatus === 'SUBSCRIBED') {
        this.editUser.subscriptions.smsMarketingStatus = 'UNSUBSCRIBE_REQUESTED';
      }

      if (this.editUser.newsletterEmailState) {
        this.editUser.subscriptions.newsletterEmailStatus = 'SUBSCRIBE_REQUESTED';
      } else {
        this.editUser.subscriptions.newsletterEmailStatus = 'UNSUBSCRIBE_REQUESTED';
      }

      try {
        await this.userService.update(this.editUser);
        this.setUser();
        this.notificationService.createNotification('User info successfully updated.', 'success');
        this.editableInfo = false;
      } catch (errorResponse: any) {
        if (errorResponse.error.ErrorCode.startsWith('SUBSCRIPTIONS_')) {
          this.setUser(errorResponse.error.ErrorData);
          this.notificationService.createNotification(errorResponse.error.Message, 'warn');
        } else {
          this.setUser();
          this.notificationService.createNotification(errorResponse.error.Message, 'error');
        }
      }
    } else {
      this.notificationService.createNotification('Emails do not match.', 'error');
    }
  }

  public resetUserInfo(): void {
    this.setUser();
    this.editableInfo = false;
  }

  public resetPasswordForm(): void {
    this.passwordForm.nativeElement.reset();
  }

  public popChangePassword($event) {
    $event.currentTarget.blur();
    const dialogRef1 = this.dialog.open(UserDialogComponent);
    const instance1 = dialogRef1.componentInstance;

    instance1.configs = {
      view: 'update password',
      page : 'update password',
      closeMethod: 'x',
      user: this.user
    };
  }

  public showSMSDisclaimer($event): void {
    if ($event) {
      this.editUser.smsMarketingState = $event;
      const dialogRef = this.dialog.open(YesNoDialogComponent, {});
      let instance = dialogRef.componentInstance;
      instance.data = {
        closeMethod: null,
        title: 'SMS Marketing Disclaimer',
        message: 'By checking this box, you agree to receive recurring automated promotional and personalized marketing ' +
          'text messages (e.g. cart reminders) from Matboard & More at the cell number used when signing up. Consent ' +
          'is not a condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies. ' +
          'Msg & data rates may apply. View <a href="/terms-conditions">Terms</a> & <a href="/privacy-policy">Privacy Policy</a>.',
          yesButtonText: 'Accept',
        noButtonText: 'Decline'
      };
      dialogRef.afterClosed().subscribe((result: boolean) => {
        this.editUser.smsMarketingState = result;
      });
    } else {
      this.editUser.smsMarketingState = false;
    }
  }
}
